import { arrayOf, Schema } from 'normalizr';


const PAYOUT_REQUEST_SCHEMA = new Schema('payoutRequests');
const PAYOUT_FEE_SCHEMA = new Schema('payoutFees');

export const PAYOUT_REQUESTS_SCHEMA = {
  items: arrayOf(PAYOUT_REQUEST_SCHEMA),
};

export const PAYOUT_FEES_SCHEMA = {
  items: arrayOf({
    payoutRequest: PAYOUT_REQUEST_SCHEMA,
    fee: PAYOUT_FEE_SCHEMA,
  }),
};
